import { Box, Flex, Section } from '@radix-ui/themes';

import { AvailableContentSection } from './AvailableContent/AvailableContentSection';
import { GlobalInfoSection } from './GlobalInformation/GlobalInfoSection';
import { TechnicalDetailsSection } from './GlobalInformation/TechnicalDetailsSection';
import { SummarySection } from './Summary/SummarySection';

export const PreviewTab = () => {
    return (
        <Section size={'1'}>
            <Section>
                <Flex gap={'8'} justify={'between'} align={'stretch'}>
                    <Box px={'5%'} width={{ initial: '100%', md: '45%' }}>
                        <SummarySection />
                    </Box>
                </Flex>
            </Section>

            <Section>
                <Flex width={'100%'} flexGrow={'1'} gap={'9'}>
                    <Box flexGrow={'1'}>
                        <GlobalInfoSection />
                    </Box>
                    <Box flexGrow={'1'}>
                        <TechnicalDetailsSection />
                    </Box>
                </Flex>
            </Section>

            <Section>
                <AvailableContentSection />
            </Section>
        </Section>
    );
};
